import { useLingui } from '@lingui/react/macro';
import { ArrowRight, Mobile } from 'iconsax-reactjs';
import { useSessionStorage } from 'react-use';
import { Button } from '@/shared/Button';
import { Dialog } from '@/shared/Dialog';
import { useRuntimeEnv } from '@/shared/runtimeEnv';

export const OpenAppDialog = () => {
  const { t } = useLingui();
  const runtimeEnv = useRuntimeEnv();
  const showOpenAndroidApp =
    runtimeEnv.hasRelatedApps &&
    runtimeEnv.os?.name === 'Android' &&
    !runtimeEnv.isStandalone;
  const [isDismissed, setIsDismissed] = useSessionStorage(
    'app-dialog-dismissed',
    false,
  );
  const androidDeepLink = `${window.location.href.replace(window.location.protocol, 'intent:')}#Intent;scheme=https;package=io.iqx.app;end`;

  return (
    <Dialog
      open={!isDismissed && showOpenAndroidApp}
      onClose={() => setIsDismissed(true)}
      position="bottom"
      closeButton={false}
      className="flex flex-col gap-3"
    >
      <Button
        block
        variant="transparent"
        size={12}
        className="w-full justify-start gap-1"
        onClick={() => setIsDismissed(true)}
      >
        <ArrowRight size={18} />
        {t`Continue in Browser`}
      </Button>
      {showOpenAndroidApp && (
        <a className="contents" href={androidDeepLink}>
          <Button
            block
            variant="primary"
            size={12}
            className="w-full justify-start gap-1"
          >
            <Mobile size={18} />
            {t`Open in Android App`}
          </Button>
        </a>
      )}
    </Dialog>
  );
};
